import { render } from "./addgallery.vue?vue&type=template&id=bbacc3f8&scoped=true"
import script from "./addgallery.vue?vue&type=script&lang=js"
export * from "./addgallery.vue?vue&type=script&lang=js"

import "./addgallery.vue?vue&type=style&index=0&id=bbacc3f8&lang=scss&scoped=true"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbacc3f8"]])

export default __exports__